const STORAGE_KEY = 'preheader_dismissed'
const html = document.documentElement

function updateHeight(bar) {
  const h = bar.classList.contains('is-hidden') ? 0 : bar.offsetHeight
  html.style.setProperty('--preheader-h', h + 'px')
}

export default function initPreheader() {
  const bar = document.querySelector('.js-preheader')

  if (!bar) {
    html.style.setProperty('--preheader-h', '0px')
    return
  }

  const version = bar.dataset.version
  const stored  = localStorage.getItem(STORAGE_KEY)

  if (stored === version) {
    // Correct version dismissed — keep hidden, clean up html attr
    bar.classList.add('is-hidden')
    html.style.setProperty('--preheader-h', '0px')
    return
  }

  // Version changed or never dismissed — show bar, remove stale attr
  html.removeAttribute('data-ph-dismissed')
  bar.classList.remove('is-hidden')

  updateHeight(bar)

  // Watch for height changes (font load, resize)
  const ro = new ResizeObserver(() => updateHeight(bar))
  ro.observe(bar)

  bar.querySelector('.js-preheader-close').addEventListener('click', function () {
    bar.classList.add('is-hidden')
    localStorage.setItem(STORAGE_KEY, version)
    html.setAttribute('data-ph-dismissed', version)
    html.style.setProperty('--preheader-h', '0px')
    ro.disconnect()
  })
}
